<template>

  <v-card flat color="grey-lighten-4">
    <v-card-title>
      {{ $t("components.OnboardingMethodsSelector.title") }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t("components.OnboardingMethodsSelector.subtitle") }}
    </v-card-subtitle>
    <v-divider class="my-2"/>
    <v-card-text>

      <configuration-section-row v-for="(c, index) in methods" :key="index">
        <template #name>
          {{ $t(`components.OnboardingMethodsSelector.${index}`) }}
        </template>
        <template #comment>
          {{ $t(`components.OnboardingMethodsSelector.${index}_description`) }}
        </template>

        <labeled-switch
          v-model="methods[index]"
        />
      </configuration-section-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="secondary"
        @click="reset"
        :disabled="!changed"
        variant="text"
      >
        {{ $t('buttons.reset') }}
      </v-btn>
      <v-btn
        color="primary"
        @click="confirmVisible = true"
        :disabled="!changed"
        variant="text"
      >
        {{ $t('buttons.apply') }}
      </v-btn>
    </v-card-actions>
  </v-card>

  <confirm-dialog
    :title="$t('common.confirm_title')"
    :text="$t('common.confirm_text')"
    v-model="confirmVisible"
    @confirm="save"
    @cancel="confirmVisible = false"
  />
</template>
<script setup lang="ts">
import {useGlobalStore} from "@/store";
import {ref, computed} from "vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import {isEqual} from "lodash";
import LabeledSwitch from "@/components/LabeledSwitch.vue";
import {isYapiError, YapiError} from "@YenzaCT/sdk";
import ConfigurationSectionRow from "@/pages/Settings/AppConfigurationPage/components/ConfigurationSectionRow.vue";

const store = useGlobalStore();

const confirmVisible = ref(false);
const methods = ref({
  ...store.appConfiguration.onboardingMethods
});

const changed = computed(() => !isEqual(store.appConfiguration.onboardingMethods, methods.value));

function reset() {
  methods.value = {...store.appConfiguration.onboardingMethods};
}

async function save() {
  try {
    await store.saveAppConfiguration("onboardingMethods", methods.value);
    store.showSnackbar("Onboarding Methods updated");
  } catch (e) {
    if (isYapiError(e)) {
      const yError = e as YapiError;
      await store.handleYapiError(yError);
    } else {
      throw e;
    }
  } finally {
    confirmVisible.value = false;
    reset();
  }
}
</script>

<style scoped>

</style>
